var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 48 48",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m34 7h4a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m34 4a1 1 0 0 0 .446-.1l4-2a1 1 0 1 0 -.894-1.79l-4 2a1 1 0 0 0 .448 1.89z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m38.447 10.105-4-2a1 1 0 0 0 -.894 1.79l4 2a1 1 0 1 0 .894-1.79z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m24.533 22.565a7 7 0 0 1 -1.533-4.371v-1.194a1 1 0 0 0 -1-1h-8a1 1 0 0 0 -.914.594l-3.31 7.449a8.984 8.984 0 0 0 -.776 3.657v15.3a5 5 0 0 0 5 5h12a5 5 0 0 0 5-5v-9.193a9 9 0 0 0 -1.973-5.625zm2.467 17.435a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2-2v-5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m15 35h10v5h-10z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m29.5 4.5h-1.523v-.507a2 2 0 0 0 -2-1.993h-9.977a7 7 0 0 0 -7 7.011 1 1 0 0 0 1 .989h4a1 1 0 0 1 1 1v3h6v-1a1.985 1.985 0 0 1 .079-.526 5.868 5.868 0 0 0 3.921 1.526 1 1 0 0 0 0-2 3.845 3.845 0 0 1 -2.48-.935 1.95 1.95 0 0 1 .48-.065h2.993a2 2 0 0 0 2-2.007v-.493h1.507a1.5 1.5 0 0 0 1.5-1.5v-1a1.5 1.5 0 0 0 -1.5-1.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpray);
export default __webpack_public_path__ + "static/media/spray.82bb01cf3bcbe584f93ef45199306671.svg";
export { ForwardRef as ReactComponent };